import React, { useState } from "react";
import { FileDown, Mail } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const ReceiptButtons = ({ number, light }) => {
  const [busy, setBusy] = useState(false);
  const cls = light
    ? "inline-flex items-center gap-1.5 rounded-full border border-[#E4DBCD] bg-white px-3.5 py-2 text-xs text-[#3A342C] hover:border-[#9A7445] transition-colors"
    : "inline-flex items-center gap-1.5 border border-[#4A4A46] px-3 py-2 text-xs text-[#C9BFAF] hover:border-[#C49A6C] hover:text-[#C49A6C] transition-colors";
  const email = async () => {
    setBusy(true);
    try {
      await api.post(`/admin/receipts/${number}/email`);
      toast.success("Receipt emailed to the store email · تم إرسال الإيصال");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="flex flex-wrap gap-2">
      <a href={`${BASE}/api/admin/receipts/${number}.pdf?v=${Date.now()}`} target="_blank" rel="noreferrer" className={cls} data-testid={`receipt-pdf-${number}`}>
        <FileDown size={14} /> Receipt PDF · الإيصال
      </a>
      <button type="button" onClick={email} disabled={busy} className={`${cls} disabled:opacity-40`} data-testid={`receipt-email-${number}`}>
        <Mail size={14} /> {busy ? "…" : "Email receipt · إرسال"}
      </button>
    </div>
  );
};
